import { Box, CircularProgress, Skeleton, Typography } from "@mui/material";
import GlassCard from "./GlassCard";

export default function LoadingState({ text = "Cargando...", variant = "page" }) {
  if (variant === "inline") {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 5,
          gap: 1.5,
        }}
      >
        <CircularProgress size={28} />
        {text && (
          <Typography sx={{ fontWeight: 900, opacity: 0.85 }}>{text}</Typography>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 2, px: { xs: 1, sm: 0 } }}>
      <GlassCard>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <CircularProgress size={22} />
          <Typography sx={{ fontWeight: 900 }}>{text}</Typography>
        </Box>
        <Box sx={{ mt: 2 }}>
          <Skeleton variant="rounded" height={56} sx={{ borderRadius: 3 }} />
          <Skeleton variant="text" height={28} sx={{ mt: 1 }} />
          <Skeleton variant="text" height={24} width="60%" />
        </Box>
      </GlassCard>
    </Box>
  );
}
